import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cookie-toast-wrap"
}
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "cookie-toast" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["alt"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "links" }
const _hoisted_9 = { class: "item action" }
const _hoisted_10 = { class: "item tech" }
const _hoisted_11 = { class: "item custom" }
const _hoisted_12 = { class: "list-item" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = {
  class: "info",
  "data-full": ""
}
const _hoisted_15 = { class: "type" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "info" }
const _hoisted_18 = { class: "type" }
const _hoisted_19 = { class: "action" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = { class: "info" }
const _hoisted_22 = { class: "type" }
const _hoisted_23 = { class: "action" }
const _hoisted_24 = { class: "confirm" }

import { ref, onBeforeMount } from "vue";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'CookieToast',
  setup(__props) {

const localizer: any = Localizer;
const isCookieToast = ref<boolean>(false);
const isCustomize = ref<boolean>(false);
const isActivateStatistics = ref<boolean>(false);
const isActivateProfiling = ref<boolean>(false);
const customizeCookieValues = ref<string[]>(["tech"]);
const routes = (window as any).App.routes;

onBeforeMount(() => {
    if (!CookieHelper.isCookiePolicy()) {
        isCookieToast.value = true;
        const el = document.body;        
        el.classList.add("toast-active");
    }
});

function setCookieToast() {
    CookieHelper.setCookiePolicyAll();
    isCookieToast.value = false;
    window.location.reload();
}

function setOnlyTech() {
    CookieHelper.removeCookiePolicyAll();
    isCookieToast.value = false;
    window.location.reload();
}

function setCustomize() {
    isCustomize.value = !isCustomize.value;
}

function setStatistics() {
    isActivateStatistics.value = !isActivateStatistics.value;

    if (isActivateStatistics.value) {
        customizeCookieValues.value.push("stat");
    } else {
        let index = customizeCookieValues.value.indexOf("stat");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setProfiling() {
    isActivateProfiling.value = !isActivateProfiling.value;

    if (isActivateProfiling.value) {
        customizeCookieValues.value.push("profile");
    } else {
        let index = customizeCookieValues.value.indexOf("profile");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setCustomCookie() {
    CookieHelper.setCookie("ckp", customizeCookieValues.value.join("|"), 365);
    isCookieToast.value = false;
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (isCookieToast.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setOnlyTech())),
              class: "close"
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("img", {
                src: "/images/close-dark.svg",
                width: "18",
                height: "18",
                class: "image",
                alt: "MlEngraving"
              }, null, -1)
            ]))]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: "/images/cookie.svg",
                  class: "icon",
                  width: "18",
                  height: "18",
                  alt: _unref(localizer).get('CookieToast.Common.Title')
                }, null, 8, _hoisted_6),
                _createTextVNode(_toDisplayString(_unref(localizer).get("CookieToast.Common.Title")), 1)
              ]),
              _createElementVNode("span", {
                innerHTML: _unref(localizer).get('CookieToast.Common.Description', _unref(routes).Terms_CookiePolicy)
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (setCookieToast())),
                  class: "button",
                  "data-border": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.AgreeAll")), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (setOnlyTech())),
                  class: "button",
                  "data-border": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.OnlyTechnicians")), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (setCustomize())),
                  class: "button",
                  "data-border": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.Customize")), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(['customize', !isCustomize.value ? 'hden' : ''])
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(localizer).get("CookieToast.Common.Technicians")), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(localizer).get("CookieToast.Common.Technicians_Description")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(localizer).get("CookieToast.Common.Stat")), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(localizer).get("CookieToast.Common.Stat_Description")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    (isActivateStatistics.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (setStatistics())),
                          class: "button",
                          "data-border": ""
                        }, _toDisplayString(_unref(localizer).get("CookieToast.Common.Deactivate")), 1))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (setStatistics())),
                          class: "button",
                          "data-border": ""
                        }, _toDisplayString(_unref(localizer).get("CookieToast.Common.Activate")), 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(localizer).get("CookieToast.Common.Profiling")), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(localizer).get("CookieToast.Common.Profiling_Description")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    (isActivateProfiling.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (setProfiling())),
                          class: "button",
                          "data-border": ""
                        }, _toDisplayString(_unref(localizer).get("CookieToast.Common.Deactivate")), 1))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (setProfiling())),
                          class: "button",
                          "data-border": ""
                        }, _toDisplayString(_unref(localizer).get("CookieToast.Common.Activate")), 1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (setCustomCookie())),
                  class: "button",
                  "data-blue": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.SavePreferences")), 1)
              ])
            ], 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})